export default __webpack_public_path__ + "static/media/Mulish-SemiBold.9f38b9b7.ttf";